var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgServicios(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 130,
    viewBox: "0 0 1280 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_189_762",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1280,
    height: 130
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 130,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_189_762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1281 1844C1281 1866.09 1263.09 1884 1241 1884L640.5 1884L40.0001 1884C17.9087 1884 0.000122424 1866.09 0.00012286 1844L0.000156995 115.977C0.000157398 95.5561 15.3824 78.414 35.684 76.2105L632.208 11.4656C635.059 11.1561 637.935 11.1542 640.787 11.4599L1245.26 76.253C1265.59 78.4316 1281 95.584 1281 116.025L1281 1844Z",
    fill: "#F8F8F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgServicios);
export default __webpack_public_path__ + "static/media/bg-servicios.243437adefc8507d37e9bf3163ad489c.svg";
export { ForwardRef as ReactComponent };